/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

jQuery(function($) {


  let thisBlock = $('.wp-block-yuna-serena-stays-place-locations-type-slider');

  thisBlock.each(function (){
    let currentBlock = $(this);

    let thisSlider = currentBlock.find('.place-location-slider');
    let thisPrevBtn = currentBlock.find('.control.prev');
    let thisNextBtn = currentBlock.find('.control.next');

    let slidesCount = thisSlider.find('.slide').length;

    if (slidesCount < 4 && slidesCount > 2) {
      currentBlock.find('.controls-wrapper').addClass('d-none');

      thisSlider.slick({
        autoplay: false,
        autoplaySpeed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              dots: true
            }
          },
        ]
      });
    }else if (slidesCount < 3){
      currentBlock.find('.controls-wrapper').addClass('d-none');
      thisSlider.addClass('short');

      thisSlider.slick({
        autoplay: false,
        autoplaySpeed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              fade: true,
              dots: true
            }
          },
        ]
      });
    }else{
      thisSlider.slick({
        autoplay: false,
        autoplaySpeed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              dots: true
            }
          },
        ]
      });
    }

    thisPrevBtn.click(function(e){
      e.preventDefault();

      thisSlider.slick('slickPrev');
    });

    thisNextBtn.click(function(e){
      e.preventDefault();

      thisSlider.slick('slickNext');
    });

  })


});
